export function cpfMask(value){
    if (!value) return ""
    value=value.replace(/\D/g,"")                    
    value=value.replace(/(\d{3})(\d)/,"$1.$2")       
    value=value.replace(/(\d{3})(\d)/,"$1.$2")       
    value=value.replace(/(\d{3})(\d{1,2})$/,"$1-$2") 
    return value
}
